export enum PointSizeType {
  FIXED = 0,
  ADAPTIVE = 1, // Not supported yet
  ADAPTIVE_BY_DISTANCE = 2,
}
